// extracted by mini-css-extract-plugin
export default {"configOptionSwatchImage":"ImageSwatch-configOptionSwatchImage-1dJ"};